// extracted by mini-css-extract-plugin
module.exports = {"graph__discounts":"PriceHistoryGraph-module__graph__discounts___322kn"};